function AuthenticationService (apiInstance)
{
	const api = apiInstance;

	this.login = (email, password) => {
		return api.request('POST', { email: email, password: password }, 'auth/login', { Authorization: '' }, {})
			.then(function (response) {
				return response.data.data;
			});
	}

	return this;
}

export default AuthenticationService;


// WEBPACK FOOTER //
// ./src/Services/AuthenticationService.js